import React from 'react'
import HousekeepingLogGeneral from './tabs/HousekeepingLogGeneral'
import HousekeepingLogHousekeepingType from './tabs/HousekeepingLogHousekeepingType'
import HousekeepingLogRoom from './tabs/HousekeepingLogRoom'
import HousekeepingLogAssignedTo from './tabs/HousekeepingLogAssignedTo'
import HousekeepingLogNotes from './tabs/HousekeepingLogNotes'
import HousekeepingLogHousekeepingTypePresenter from './tabs/HousekeepingLogHousekeepingTypePresenter'
import HousekeepingLogTimeline from './tabs/HousekeepingLogTimeline'
import HousekeepingLogHistory from './tabs/HousekeepingLogHistory'

export default class HousekeepingLogWorkspace extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.request_cleaning) {
      return (
        <div className="tab-content">
          <HousekeepingLogGeneral {...this.props} />
          <HousekeepingLogRoom {...this.props}/>
          <HousekeepingLogAssignedTo {...this.props}/>
          {this.props.read_only ? <HousekeepingLogHousekeepingTypePresenter {...this.props}/> : <HousekeepingLogHousekeepingType {...this.props}/>}
          <HousekeepingLogNotes {...this.props} />
          <HousekeepingLogTimeline {...this.props} />
          {this.props.read_only && this.props.history_visible !== false ?
          <HousekeepingLogHistory {...this.props} /> : null}
        </div>
      )
    } else {
      return (
        <div className="tab-content">
          <HousekeepingLogGeneral {...this.props} />
          <HousekeepingLogRoom {...this.props}/>
          <HousekeepingLogAssignedTo {...this.props}/>
          <HousekeepingLogHousekeepingType {...this.props}/>
          <HousekeepingLogNotes {...this.props} />
        </div>
      );
    };
  };

};
